import { createContext } from 'react';
import { useChartsData } from '../../hooks/useChartsData';
import { useFiltersContext } from '../../Filters/hooks/useFiltersContext';
import { coresMescladasArray } from '../../styles/colors';

export const ServicesChartsDataContext = createContext();

export const defaultColors = coresMescladasArray

const ServicesChartsDataProvider = ({
    module,
    queryConfig,
    children,
    subtitlesMap,
    ignoreMonth = false
}) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(queryConfig, {
        location: filters.unidade?.value,
        year: filters.ano?.value,
        month: ignoreMonth ? '' : filters.competencia?.value,
        city: filters.cidade?.value
    });

    const chartData = data
        ? {
              counterYear: data.counterYear || [],
              selectedYear: data.selectedYear || []
          }
        : {
              counterYear: [],
              selectedYear: []
          };

    const subtitles = subtitlesMap[queryConfig.key]
        ? subtitlesMap[queryConfig.key].map((item) => item.description)
        : Array.from(
              new Set(data?.counterYear?.map((item) => item.description ?? '-'))
          );

    const colors = defaultColors;

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                subtitles,
                colors,
                isLoading,
                isError,
                filters,
                module,
                queryConfig,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
